import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navCategories } from '@/mocks/home';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`text-xl font-heading font-bold tracking-tight ${isScrolled || !isHome ? 'text-foreground-950' : 'text-white'}`}>
              黑料在线
            </span>
            <span className={`hidden sm:inline text-xs px-2 py-0.5 rounded-full font-medium ${
              isScrolled || !isHome ? 'bg-primary-100 text-primary-700' : 'bg-white/20 text-white'
            }`}>
              每日更新
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? isScrolled || !isHome ? 'text-primary-600' : 'text-white'
                  : isScrolled || !isHome ? 'text-foreground-800 hover:text-primary-600' : 'text-white/80 hover:text-white'
              }`}
            >
              首页
            </Link>
            {navCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled || !isHome
                    ? 'text-foreground-800 hover:text-primary-600'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <button
              className={`hidden md:flex items-center gap-1.5 text-sm font-medium whitespace-nowrap cursor-pointer px-4 py-2 rounded-full transition-all ${
                isScrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              <i className="ri-send-plane-line text-base w-4 h-4 flex items-center justify-center"></i>
              投稿爆料
            </button>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
                isScrolled || !isHome ? 'text-foreground-800 hover:bg-background-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-3 px-2">
            <Link
              to="/"
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === '/' ? 'bg-primary-50 text-primary-700' : 'text-foreground-800 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {navCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {cat.name}
              </Link>
            ))}
            <div className="mt-2 px-4">
              <button className="w-full flex items-center justify-center gap-1.5 text-sm font-medium bg-primary-500 text-white px-4 py-2.5 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-send-plane-line text-base w-4 h-4 flex items-center justify-center"></i>
                投稿爆料
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}